<div class="announcement" *ngIf="!closed && ads?.length" @openClose>
  <div class="announcement__inner">
    <div class="announcement__header">
      <div class="announcement__title-wrap">
        <div class="announcement__icon">
          <i class="pi pi-megaphone"></i>
        </div>
        <div class="announcement__title">Объявление</div>
      </div>

      <button
        type="button"
        class="announcement__close"
        (click)="closeNews()"
        aria-label="Закрыть"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>

    <div class="announcement__content-wrapper">
      <div class="announcement__content">
        <div *ngFor="let ad of ads" class="announcement__item">
          <div class="announcement__item-title">
            {{ ad.ad_title }}
          </div>

          <div
            class="announcement__item-text"
            [innerHTML]="ad.safe_ad_content"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
